import { createTheme } from '@mui/material/styles';

const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#F7E900',
      contrastText: '#000000',
    },
    secondary: {
      main: '#dc004e',
    },
    background: {
      default: 'transparent',
      paper: 'rgba(255, 255, 255, 0.95)',
      alternate: '#EEEEEE',
    },
    text: {
      primary: '#000000',
      secondary: '#666666',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          color: '#000000',
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        // background.paper vaut rgba(255,255,255,0.95) : un Paper translucide oblige le
        // compositeur à blender toute la surface animée avec le fond fixe de index.css à
        // chaque frame du slide. Opaque uniquement ici, pour ne pas toucher les autres
        // surfaces (cartes, menus, tables) qui, elles, ne sont pas animées.
        paper: {
          backgroundColor: '#FFFFFF',
        },
      },
    },
  },
});

export default lightTheme;